import { observer } from 'mobx-react-lite'
import { ContentError } from '@/components/ContentError'
import { type EditPersonalProfileDialogViewModel } from '@/features/jobs/info-gathering/individual-info/components/EditPersonalProfileDialog/EditPersonalProfileDialogViewModel'
import { type DependentProfileViewModel } from '@/features/jobs/info-gathering/individual-info/DependentProfileViewModel'
import { DependentsProfile } from '@/features/jobs/info-gathering/individual-info/components/DependentsProfile'

export interface DependentsProfileContainerProps {
  vm: DependentProfileViewModel
  editVm: EditPersonalProfileDialogViewModel | null
}

export const DependentsProfileContainer = observer(
  function DependentsProfileContainer({
    vm,
    editVm,
  }: DependentsProfileContainerProps) {
    if (!vm.dependents.length) {
      return null
    }

    const renderProfiles = (isLoading: boolean) => (
      <DependentsProfile
        dependents={vm.dependents}
        isLoading={isLoading}
        isEditable={!!editVm?.canShow}
        onEdit={editVm?.showDependents}
        editButtonTestId="update-dependents-information-button"
      />
    )

    return vm.fetch.match({
      pending: () => renderProfiles(true),
      rejected: (err) => <ContentError error={err} />,
      resolved: () => renderProfiles(false),
    })
  },
)
